// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 8.00391V6H6.00391V6.00391H6V8.00391H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 13.0039V11H6.00391V11.0039H6V13.0039H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 18.0039V16H6.00391V16.0039H6V18.0039H8.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 2H2V22H17V16H22V10H12V2ZM10 4V20H4V4H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18H19V22H22V18Z"}}]};

const City1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-1-filled',
    ref,
    icon: element,
  },
));

City1FilledIcon.displayName = 'City1FilledIcon';

export default City1FilledIcon;
